const PHRASES = [
  "Independent brokerage",
  "50+ A-rated carriers",
  "Tax-advantaged strategies",
  "2,000+ clients served annually",
  "$150M+ retirement funds protected",
  "0% market downside",
  "Licensed nationwide",
  "Family-first planning",
];

const Track = ({ ariaHidden = false }) => (
  <div
    className="flex shrink-0 animate-marquee-track"
    aria-hidden={ariaHidden || undefined}
  >
    {PHRASES.map((p, j) => (
      <span
        key={j}
        className="inline-flex items-center text-sm tracking-[0.25em] uppercase font-semibold text-white/70 px-7"
      >
        {p}
        <span className="ml-7 w-1.5 h-1.5 rounded-full bg-[#29ABE2]" />
      </span>
    ))}
  </div>
);

export const TrustMarquee = () => (
  <section
    data-testid="trust-marquee"
    className="bg-[#0B132B] border-y border-white/10 py-5 overflow-hidden relative"
  >
    <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0B132B] to-transparent z-10 pointer-events-none" />
    <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0B132B] to-transparent z-10 pointer-events-none" />
    <div className="flex w-max">
      <Track />
      <Track ariaHidden />
    </div>
  </section>
);
